(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["diamond-engraving-upload"] && !Shopify.designMode) return;
  try {
    function validateDiamondReference(input) {
    const file = input.files[0];
    const valid = !file || (['image/jpeg', 'image/png', 'image/webp'].includes(file.type) && file.size <= 10 * 1024 * 1024);
    input.setCustomValidity(valid ? '' : input.dataset.errorMessage);
    return valid;
  }
  function updateDiamondReference(input) {
    const root = input.closest('[data-engraving-upload]');
    const file = input.files[0];
    const valid = validateDiamondReference(input);
    const preview = root.querySelector('[data-engraving-preview]');
    if (preview.dataset.objectUrl) { URL.revokeObjectURL(preview.dataset.objectUrl); delete preview.dataset.objectUrl; }
    preview.removeAttribute('src');
    preview.hidden = true;
    root.querySelector('[data-engraving-selection]').hidden = !file || !valid;
    root.querySelector('[data-diamond-filename]').textContent = file && valid ? file.name : '';
    const error = root.querySelector('[data-engraving-error]');
    error.textContent = valid ? '' : input.dataset.errorMessage;
    error.hidden = valid;
    input.setAttribute('aria-invalid', String(!valid));
    if (file && valid) {
      const url = URL.createObjectURL(file);
      preview.dataset.objectUrl = url;
      preview.src = url;
      preview.hidden = false;
      preview.onerror = function() { preview.hidden = true; };
    }
  }
  document.addEventListener('change', function(event) {
    if (event.target.matches('[data-diamond-engraving-file]')) updateDiamondReference(event.target);
  });
  document.addEventListener('click', function(event) {
    const remove = event.target.closest('[data-engraving-remove]');
    if (!remove) return;
    const input = remove.closest('[data-engraving-upload]').querySelector('[data-diamond-engraving-file]');
    input.value = '';
    updateDiamondReference(input);
    input.focus();
  });
  document.addEventListener('submit', function(event) {
    if (!(event.target instanceof HTMLFormElement)) return;
    const input = event.target.querySelector('[data-diamond-engraving-file]');
    if (!input || !input.files.length) return;
    event.stopImmediatePropagation();
    if (!validateDiamondReference(input)) {
      event.preventDefault();
      updateDiamondReference(input);
      input.reportValidity();
      return;
    }
    event.target.enctype = 'multipart/form-data';
  }, true);
  } catch(e) { console.error(e); }
})();

})();
